import type { InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

import { BUTTON_EVENT_CATEGORY, type TrackingProps, trackEvent } from "utils/amplitude";

type RadioButtonProps = InputHTMLAttributes<HTMLInputElement> &
  TrackingProps & {
    containerClassName?: string;
  };

export const RadioButton = ({
  ref,
  containerClassName,
  id,
  children,
  eventName,
  eventProps = {},
  onChange,
  ...props
}: RadioButtonProps & { ref?: React.Ref<HTMLInputElement> }) => {
  const handleChange = eventName
    ? (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) onChange(e);
        trackEvent(eventName, {
          ...BUTTON_EVENT_CATEGORY,
          ...eventProps,
        });
      }
    : onChange;

  return (
    <div className={twMerge("mc-authoring flex items-center", containerClassName)}>
      <input
        className="mc-authoring-radio mr-2"
        id={id}
        type="radio"
        {...props}
        ref={ref}
        onChange={handleChange}
      />
      <label htmlFor={id}>{children}</label>
    </div>
  );
};

RadioButton.displayName = "RadioButton";
